// Extract a human-readable message from a failed User-module API call.
//
// The Breadstack backend returns a `{ message, code, data }` envelope on
// error (e.g. the 400 "User(s) already exist in organization." from the invite
// endpoint). axios surfaces that body at `err.response.data.message`. We fall
// back to the raw Error message, then a caller-supplied generic copy so the UI
// never shows a blank error. Mirrors the extraction pattern used by
// `features/Location/utils/getApiErrorMessage`.
export function getApiErrorMessage(err: unknown, fallback: string): string {
  const fromEnvelope = (err as { response?: { data?: { message?: string } } })
    ?.response?.data?.message
  if (typeof fromEnvelope === 'string' && fromEnvelope.trim()) {
    return fromEnvelope
  }
  const fromError = (err as { message?: string })?.message
  if (typeof fromError === 'string' && fromError.trim()) return fromError
  return fallback
}
